<template>
  <div @click.stop="changeDisplay()" :class="hideBar ? 'offline-indicator hide':'offline-indicator'">
    <div class="online" v-if="online">
      <div class="online-mode" v-show="!hideOnOnline && !forceOfflineMode">
        <div class="text-w">
          <span v-show="!hideBar && displayText">Online mode, try
          <span @click="enableOfflineMode" class="mode-switcher">offline mode</span>
          when connection slow.</span>
          <i class="material-icons icon" v-show="hideBar">language</i>
        </div>
      </div>
      <div class="force-offline-mode" v-show="forceOfflineMode">
        <div class="text-w">
          <span v-show="!hideBar && displayText">Force Offline Mode,
          <span @click="disableOfflineMode" class="mode-switcher">back online.</span></span>
          <i class="material-icons icon" v-show="hideBar">airplanemode_active</i>
        </div>
      </div>
    </div>
    <div class="offline" v-if="!online">
      <div class="offline-mode">
        <div class="text-w">
          <span v-show="!hideBar && displayText">Your device is currently offline.</span>
          <i class="material-icons icon" v-show="hideBar">perm_scan_wifi</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OfflineIndicator',
  props: {
    hideOnOnline: Boolean
  },
  data () {
    return {
      hideBar: true,
      displayText: false
    }
  },
  computed: {
    forceOfflineMode: function () {
      return this.$store.state.forceOfflineMode
    },
    online: function () {
      return this.$store.state.networkStatus
    }
  },
  methods: {
    enableOfflineMode: function () {
      this.$store.dispatch('enableOfflineMode')
    },
    disableOfflineMode: function () {
      this.$store.dispatch('disableOfflineMode')
    },
    changeDisplay: function () {
      let that = this
      setTimeout(() => {
        that.displayText = !that.displayText
      }, that.displayText ? 0 : 200)

      this.hideBar = !this.hideBar
    }
  }
}
</script>

<style>
.offline-indicator {
  position: fixed;
  left: 0;
  width: 100%;
  bottom: 16px;
  z-index: 999;
  text-align: center;
  line-height: 25px;
  cursor: pointer;
  border-radius: 0 20px 20px 0;
  overflow: hidden;
  transition: all 0.2s ease;
  min-height: 36px;
}

.hide {
  width: 40px;
  transition: all 0.2s ease;
}

.text-w {
  display: flex;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
  padding: 6px 0;
}

.online-mode {
  /* height: 40px; */
  background-color: rgb(99, 138, 21);
  color: #ffffff;
  min-height: 36px;
}

.force-offline-mode {
  background-color: rgb(223, 92, 16);
  color: #ffffff;
  min-height: 36px;
}

.offline-mode {
  background-color: rgb(32, 29, 29);
  color: #ffffff;
  min-height: 36px;
}

.mode-switcher {
  text-decoration-line: underline;
  font-weight: 700;
  cursor: pointer;
}
</style>
